import React from "react";

const DocumentExpiry = () => {
  const docExpiryRecords = [
    {
      docId: "1",
      docName: "Rent",
      expDate: "12-12-2025",
      daysOfExpiry: 19,
    },
    {
      docId: "2",
      docName: "Rent",
      expDate: "12-12-2025",
      daysOfExpiry: 19,
    },
    {
      docId: "3",
      docName: "Rent",
      expDate: "12-12-2025",
      daysOfExpiry: 19,
    },
  ];
  return (
    <div>
      <div className="flex justify-left items-center mb-6">
        <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
        <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
          
          <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
            DOCUMENT EXPIRY
          </span>
        </h6>
      </div>
      <div className="max-h-[400px] overflow-auto border rounded-md">
        <table className="min-w-full text-xs">
          <thead className="sticky top-0 bg-[#2663EB] text-white">
            <tr>
              <th className="px-2 py-2 font-normal">Doc ID</th>
              <th className="px-2 py-2 font-normal">Name</th>
              <th className="px-2 py-2 font-normal">Expiry Date</th>
              <th className="px-2 py-2 font-normal">Days of Expiry</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {docExpiryRecords?.map((d, i) => {
              return (
                <tr key={i} className={`cursor-pointer hover:bg-gray-50`}>
                  <td className="px-2 py-2 border">{d?.docId}</td>
                  <td className="px-2 py-2 border">{d?.docName}</td>
                  <td className="px-2 py-2 border">{d?.expDate}</td>
                  <td className="px-2 py-2 border">{d?.daysOfExpiry}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DocumentExpiry;
